export const ORDER_ITEM_STATUSES = [
  "Pending",
  "Confirmed",
  "Processing",
  "Packed",
  "Shipped",
  "In Transit",
  "Out for Delivery",
  "Delivered",
  "Cancelled",
  "Returned",
  "Failed Delivery"
];

export const DEFAULT_ORDER_ITEM_STATUS = "Pending";

export function normalizeOrderItemStatus(value) {
  if (value == null || String(value).trim() === "") return DEFAULT_ORDER_ITEM_STATUS;
  const trimmed = String(value).trim();
  const match = ORDER_ITEM_STATUSES.find((s) => s.toLowerCase() === trimmed.toLowerCase());
  return match ?? DEFAULT_ORDER_ITEM_STATUS;
}
